import React, {useState} from "react"
import { FieldRenderer } from "./FormGenerator"
import { Box } from "@mui/material";

export default function AddSingleInput({ field, value = {}, onChange, parentSection }) {
    const [itemData, setItemData] = useState(value || {});

    const updateItem = (childFieldId, newVal) => {
        const updatedData = {
            ...itemData,
            [childFieldId]: newVal
        };
        setItemData(updatedData);
        onChange(field.id, updatedData, parentSection);
    };

    return (
        <Box sx={{ my: 1 }}>
            {field.fields.map((subField, index) => (
                <FieldRenderer
                    key={subField.id}
                    field={subField}
                    value={itemData ? itemData[subField.id] : undefined}
                    onChange={updateItem}
                    index={index + 1}
                    parentSection={subField.id}
                />
            ))}
        </Box>
    );
}